export enum PushType {
	ORDERS = 'ORDERS',
	COUPON = 'COUPON',
	RATING = 'RATING',
	RESERVATION = 'RESERVATION',
	NEWS = 'NEWS',
	CAMPAIGN = 'CAMPAIGN'
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/push-type.enum.ts